function formatMoney(cents) {
  return '$' + (Number(cents) / 100).toFixed(2);
}

function initNav() {
  const toggle = document.querySelector('.menu-toggle');
  const nav = document.getElementById('site-nav');
  if (!toggle || !nav) return;
  toggle.addEventListener('click', () => {
    const open = nav.classList.toggle('open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
}

function initAnnouncementTimer() {
  const el = document.querySelector('[data-ann-timer]');
  if (!el) return;
  const hours = parseInt(el.dataset.hours || '4', 10);
  const deadline = Date.now() + hours * 3600000;
  const hEl = el.querySelector('[data-ann-h]');
  const mEl = el.querySelector('[data-ann-m]');
  const sEl = el.querySelector('[data-ann-s]');
  const pad = (n) => String(n).padStart(2, '0');
  const tick = () => {
    const remaining = deadline - Date.now();
    if (remaining <= 0) {
      hEl.textContent = mEl.textContent = sEl.textContent = '00';
      return;
    }
    hEl.textContent = pad(Math.floor(remaining / 3600000));
    mEl.textContent = pad(Math.floor((remaining % 3600000) / 60000));
    sEl.textContent = pad(Math.floor((remaining % 60000) / 1000));
  };
  tick();
  setInterval(tick, 1000);
}

function initPibCarousel() {
  const root = document.querySelector('[data-pib-carousel]');
  if (!root) return;
  const slides = [...root.querySelectorAll('.pib-slide')];
  const dots = [...root.querySelectorAll('.pib-dot')];
  if (!slides.length) return;
  let current = 0;
  const goTo = (idx) => {
    slides[current].classList.remove('active');
    dots[current]?.classList.remove('active');
    current = (idx + slides.length) % slides.length;
    slides[current].classList.add('active');
    dots[current]?.classList.add('active');
  };
  dots.forEach((dot) => {
    dot.addEventListener('click', () => goTo(parseInt(dot.getAttribute('data-i'), 10)));
  });
  const starsRow = document.querySelector('.pib-stars-row');
  if (starsRow) {
    starsRow.addEventListener('click', (e) => {
      const reviews = document.getElementById('reviews');
      if (!reviews) return;
      e.preventDefault();
      reviews.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
  setInterval(() => goTo(current + 1), 4500);
}

function initGallery() {
  const mainImg = document.getElementById('main-product-img');
  const thumbs = document.querySelectorAll('.product-thumb');
  if (!mainImg || !thumbs.length) return;
  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      thumbs.forEach((t) => t.classList.remove('active'));
      thumb.classList.add('active');
      mainImg.src = thumb.dataset.src;
      mainImg.alt = thumb.dataset.alt || mainImg.alt;
    });
  });
}

function initReviewsCarousel() {
  const root = document.querySelector('[data-reviews-carousel]');
  if (!root) return;
  const track = root.querySelector('.c-prime-hp-05__track');
  const cards = [...root.querySelectorAll('.c-prime-hp-05__card')];
  const dotsWrap = root.querySelector('[data-rev-dots]');
  if (!track || cards.length < 2) {
    root.classList.add('is-ready');
    return;
  }
  let index = 0;
  cards.forEach((_, i) => {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'c-prime-hp-05__dot' + (i === 0 ? ' is-active' : '');
    b.addEventListener('click', () => go(i));
    dotsWrap.appendChild(b);
  });
  const dots = [...dotsWrap.querySelectorAll('.c-prime-hp-05__dot')];
  const go = (i) => {
    index = (i + cards.length) % cards.length;
    track.style.transform = `translateX(-${index * (cards[0].offsetWidth + 12)}px)`;
    dots.forEach((d, di) => d.classList.toggle('is-active', di === index));
  };
  root.querySelector('[data-rev-prev]')?.addEventListener('click', () => go(index - 1));
  root.querySelector('[data-rev-next]')?.addEventListener('click', () => go(index + 1));
  root.classList.add('is-ready');
}

const FREE_SHIP_CENTS = 4000;
const PAID_SHIP_CENTS = 230;

function escapeHtml(value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function parseUpsellCatalog() {
  const el = document.getElementById('cart-upsell-data');
  if (!el) return [];
  try {
    return JSON.parse(el.textContent);
  } catch {
    return [];
  }
}

function visibleProperties(properties) {
  return Object.entries(properties || {}).filter(([key, val]) => key && !key.startsWith('_') && val);
}

function uniqueSingleBookHandles(cart, catalog) {
  const byHandle = new Map(catalog.map((book) => [book.handle, book]));
  const byTitle = new Map(catalog.map((book) => [String(book.title).toLowerCase(), book]));
  const handles = new Set();
  cart.items.forEach((item) => {
    if (byHandle.has(item.handle)) handles.add(item.handle);
    visibleProperties(item.properties).forEach(([, val]) => {
      const match = byTitle.get(String(val).toLowerCase());
      if (match) handles.add(match.handle);
    });
  });
  return handles;
}

const UPSELL_PERCENT = 14;

function salePrice(cents, percent) {
  return Math.round(Number(cents) * (100 - percent) / 100);
}

function isUpsellItem(item) {
  const props = item.properties || {};
  return Boolean(props._cart_upsell || props['_cart_upsell']);
}

function lineDisplayCents(item) {
  if (isUpsellItem(item) && !item.selling_plan_allocation) {
    return salePrice(Number(item.original_price || item.price) * Number(item.quantity || 1), UPSELL_PERCENT);
  }
  return item.final_line_price;
}

function cartDisplaySubtotal(cart) {
  return (cart.items || []).reduce((sum, item) => sum + lineDisplayCents(item), 0);
}

const CartDrawer = {
  open() {
    const el = document.getElementById('cart-drawer');
    if (!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  },
  close() {
    const el = document.getElementById('cart-drawer');
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  },
  async refresh() {
    const cart = await fetch('/cart.js').then((r) => r.json());
    this.render(cart);
    return cart;
  },
  async changeLine(line, quantity) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity }),
    });
    await this.refresh();
  },
  renderShipping(cart) {
    const wrap = document.getElementById('cart-ship');
    const msg = document.getElementById('cart-ship-msg');
    const fill = document.getElementById('cart-ship-fill');
    const bar = document.getElementById('cart-ship-bar');
    const fee = document.getElementById('cart-ship-fee');
    if (!wrap || !msg || !fill) return;
    const empty = cart.item_count === 0;
    wrap.hidden = empty;
    if (empty) return;
    const sub = cartDisplaySubtotal(cart) || cart.items_subtotal_price || cart.total_price || 0;
    const unlocked = sub >= FREE_SHIP_CENTS;
    const progress = Math.min(100, Math.round((sub / FREE_SHIP_CENTS) * 100));
    wrap.classList.toggle('is-free', unlocked);
    fill.style.width = `${progress}%`;
    if (bar) {
      bar.setAttribute('aria-valuenow', Math.min(40, Math.round(sub / 100)));
    }
    if (unlocked) {
      msg.textContent = 'You unlocked FREE shipping';
      if (fee) fee.textContent = 'Free';
    } else {
      msg.textContent = `Add ${formatMoney(FREE_SHIP_CENTS - sub)} more for FREE shipping`;
      if (fee) fee.textContent = formatMoney(PAID_SHIP_CENTS);
    }
  },
  renderUpsells(cart) {
    const wrap = document.getElementById('cart-upsells');
    const list = document.getElementById('cart-upsells-list');
    const offer = document.getElementById('cart-upsells-offer');
    const title = document.getElementById('cart-upsells-title');
    if (!wrap || !list) return;
    const catalog = parseUpsellCatalog();
    const taken = uniqueSingleBookHandles(cart, catalog);
    const available = catalog.filter((book) => !taken.has(book.handle));
    if (cart.item_count === 0 || !available.length) {
      wrap.hidden = true;
      list.innerHTML = '';
      return;
    }
    const percent = UPSELL_PERCENT;
    wrap.hidden = false;
    if (title) title.textContent = 'Add another book';
    if (offer) offer.textContent = `${percent}% off extra books`;
    list.innerHTML = available.map((book) => {
      const now = salePrice(book.price, percent);
      return `
        <article class="cart-upsell">
          <img src="${escapeHtml(book.image || '')}" alt="" width="56" height="56">
          <div class="cart-upsell__copy">
            <a class="cart-upsell__title" href="${escapeHtml(book.url)}">${escapeHtml(book.title)}</a>
            <div class="cart-upsell__prices">
              <span class="cart-upsell__now">${formatMoney(now)}</span>
              <s>${formatMoney(book.price)}</s>
              <span class="cart-upsell__badge">${percent}% off</span>
            </div>
          </div>
          <button type="button" class="cart-upsell__add" data-upsell-add="${book.variantId}" data-upsell-pct="${percent}">Add</button>
        </article>
      `;
    }).join('');
    list.querySelectorAll('[data-upsell-add]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        btn.disabled = true;
        try {
          await addToCartAndOpen({
            id: Number(btn.dataset.upsellAdd),
            quantity: 1,
            properties: { _cart_upsell: String(btn.dataset.upsellPct || percent) },
          }, { open: true });
        } catch (err) {
          console.error(err);
          alert(err.message || 'Could not add that book. Try again.');
          btn.disabled = false;
        }
      });
    });
  },
  render(cart) {
    const count = document.getElementById('cart-drawer-count');
    const items = document.getElementById('cart-drawer-items');
    const empty = document.getElementById('cart-drawer-empty');
    const footer = document.getElementById('cart-drawer-footer');
    const subtotal = document.getElementById('cart-drawer-subtotal');

    document.querySelectorAll('.header-cart-count').forEach((el) => {
      el.textContent = cart.item_count;
      el.classList.toggle('is-empty', cart.item_count === 0);
    });
    if (count) count.textContent = `(${cart.item_count})`;
    if (subtotal) subtotal.textContent = formatMoney(cartDisplaySubtotal(cart) || cart.items_subtotal_price || cart.total_price);
    if (empty) empty.hidden = cart.item_count > 0;
    if (footer) footer.hidden = cart.item_count === 0;
    this.renderShipping(cart);
    if (!items) {
      this.renderUpsells(cart);
      return;
    }
    items.innerHTML = cart.items.map((item, i) => {
      const locked = /WW-MIX-|WW-SET-/.test(item.sku || '') || visibleProperties(item.properties).some(([key]) => /^Book\s+\d+/i.test(key));
      const extras = visibleProperties(item.properties)
        .map(([, val]) => escapeHtml(val))
        .join(' · ');
      const thumb = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/, '_120x$1$2') : '';
      return `
      <div class="cart-drawer-item">
        <img src="${escapeHtml(thumb)}" alt="" width="62" height="62">
        <div>
          <div class="cart-drawer-item-title">${escapeHtml(item.product_title)}</div>
          ${item.selling_plan_allocation ? `<div class="cart-drawer-item-meta">↻ ${escapeHtml(item.selling_plan_allocation.selling_plan.name)}</div>` : ''}
          ${extras ? `<div class="cart-drawer-item-meta">${extras}</div>` : ''}
          <div class="cart-drawer-item-qty">
            ${locked ? `<span>${item.quantity} book${item.quantity === 1 ? '' : 's'}</span>` : `
            <button type="button" data-drawer-minus="${i + 1}" aria-label="Decrease quantity">−</button>
            <span>${item.quantity}</span>
            <button type="button" data-drawer-plus="${i + 1}" aria-label="Increase quantity">+</button>`}
          </div>
        </div>
        <div class="cart-drawer-item-side">
          <div class="cart-drawer-item-price">${formatMoney(lineDisplayCents(item))}</div>
          <button type="button" class="cart-drawer-item-remove" data-drawer-remove="${i + 1}">Remove</button>
        </div>
      </div>
    `;
    }).join('');
    items.querySelectorAll('[data-drawer-minus]').forEach((btn) => {
      btn.addEventListener('click', () => this.changeLine(+btn.dataset.drawerMinus, cart.items[+btn.dataset.drawerMinus - 1].quantity - 1));
    });
    items.querySelectorAll('[data-drawer-plus]').forEach((btn) => {
      btn.addEventListener('click', () => this.changeLine(+btn.dataset.drawerPlus, cart.items[+btn.dataset.drawerPlus - 1].quantity + 1));
    });
    items.querySelectorAll('[data-drawer-remove]').forEach((btn) => {
      btn.addEventListener('click', () => this.changeLine(+btn.dataset.drawerRemove, 0));
    });
    this.renderUpsells(cart);
  },
};

function initCartDrawer() {
  document.querySelectorAll('[data-cart-open]').forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      CartDrawer.open();
      CartDrawer.refresh();
    });
  });
  document.querySelectorAll('[data-cart-close]').forEach((el) => {
    el.addEventListener('click', () => CartDrawer.close());
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') CartDrawer.close();
  });
  if (sessionStorage.getItem('ww-open-cart') === '1') {
    sessionStorage.removeItem('ww-open-cart');
    CartDrawer.open();
  }
  CartDrawer.refresh();
}

let holdOffCartPageUntil = 0;

function isCartPageUrl(href) {
  try {
    const url = new URL(href, location.origin);
    return url.origin === location.origin && /^\/cart\/?$/.test(url.pathname);
  } catch {
    return false;
  }
}

function holdOffCartPage(ms = 5000) {
  holdOffCartPageUntil = Date.now() + ms;
  sessionStorage.setItem('ww-open-cart', '1');
}

function stayOnCurrentPage(href) {
  if (Date.now() >= holdOffCartPageUntil || !isCartPageUrl(href)) return false;
  CartDrawer.refresh();
  CartDrawer.open();
  return true;
}

function guardCartRedirects() {
  const assign = window.location.assign.bind(window.location);
  const replace = window.location.replace.bind(window.location);
  window.location.assign = (url) => {
    if (stayOnCurrentPage(url)) return;
    assign(url);
  };
  window.location.replace = (url) => {
    if (stayOnCurrentPage(url)) return;
    replace(url);
  };
}

async function applyUpsellDiscount() {
  try {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: 'CART14' }),
    });
  } catch {
    await fetch('/discount/CART14', { redirect: 'manual', credentials: 'same-origin' }).catch(() => {});
  }
}

async function addToCartAndOpen(payload, opts = {}) {
  const open = opts.open !== false;
  holdOffCartPage();
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(payload),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(json.description || json.message || 'Could not add to cart. Try again.');
    err.payload = json;
    throw err;
  }
  const props = payload.properties || {};
  const items = payload.items || [];
  if (props._cart_upsell || items.some((item) => item.properties && item.properties._cart_upsell)) {
    await applyUpsellDiscount();
  }
  await CartDrawer.refresh();
  if (open) CartDrawer.open();
  return json;
}

async function checkoutWithItem(payload) {
  await addToCartAndOpen(payload);
}

window.WonderWhy = {
  CartDrawer,
  addToCartAndOpen,
  getSellingPlanId,
  openCart() {
    CartDrawer.refresh();
    CartDrawer.open();
  },
};

function parsePackOffers() {
  const el = document.getElementById('pack-offer-data');
  if (!el) return [];
  try {
    return JSON.parse(el.textContent);
  } catch {
    return [];
  }
}

function applyPackOffer(pack) {
  if (!pack) return;
  const select = document.getElementById('product-variant-select');
  const qty = document.getElementById('Quantity');
  if (select) {
    select.value = String(pack.id);
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }
  if (qty) qty.value = String(pack.qty);
  const total = pack.unit * pack.qty;
  const compare = (pack.compare || pack.unit) * pack.qty;
  document.querySelectorAll('[data-live-pack-price]').forEach((el) => {
    el.textContent = formatMoney(total);
  });
  document.querySelectorAll('[data-live-price]').forEach((el) => {
    el.textContent = formatMoney(total);
  });
  const save = compare - total;
  const note = document.querySelector('.pib-price-note');
  if (note && save > 0) {
    const strong = note.querySelector('strong');
    if (strong) strong.textContent = formatMoney(save);
  }
  document.querySelectorAll('[data-ww-once-price]').forEach((el) => {
    el.textContent = formatMoney(total);
  });
  document.querySelectorAll('[data-ww-sub-price]').forEach((el) => {
    el.textContent = formatMoney(Math.round(total * 0.86));
  });
}

function initBookPacks() {
  const root = document.querySelector('[data-book-packs]');
  const packs = parsePackOffers();
  if (!root || !packs.length || root.dataset.packReady) return;
  root.dataset.packReady = '1';
  const pick = (id) => packs.find((p) => String(p.id) === String(id));
  const sync = () => {
    const checked = root.querySelector('input[name="book-pack"]:checked');
    root.querySelectorAll('.book-pack').forEach((row) => {
      row.classList.toggle('is-selected', row.querySelector('input') === checked);
    });
    const pack = pick(checked?.value) || packs.find((p) => p.qty === 1) || packs[0];
    applyPackOffer(pack);
  };
  root.querySelectorAll('.book-pack').forEach((row) => {
    const input = row.querySelector('input[name="book-pack"]');
    if (!input) return;
    row.addEventListener('click', (e) => {
      e.preventDefault();
      input.checked = true;
      sync();
    });
    input.addEventListener('change', sync);
  });
  const preferred = packs.find((p) => p.qty === 1);
  if (preferred) {
    const radio = root.querySelector(`input[name="book-pack"][value="${preferred.id}"]`);
    if (radio) radio.checked = true;
  }
  sync();
}

function digits(value) {
  return String(value || '').replace(/\D/g, '');
}

function getSellingPlanId() {
  const block = document.querySelector('kaching-subscriptions-block-v2, kaching-subscriptions-block');
  try {
    const store = block && block.store;
    if (store) {
      const kind = store.currentOption?.value?.kind;
      const id = store.selectedSellingPlanId?.value;
      if (kind && kind !== 'subscription') return '';
      if (kind === 'subscription') {
        return digits(id) || digits(document.querySelector('[data-plan]')?.getAttribute('data-plan'));
      }
      if (id) return digits(id);
    }
  } catch (err) {}
  const subOn = document.querySelector('.kaching-subscriptions__card-wrapper.selected:not(.one-time-purchase)');
  const onceOn = document.querySelector('.kaching-subscriptions__card-wrapper.one-time-purchase.selected');
  if (onceOn && !subOn) return '';
  if (subOn) {
    return digits(block?.store?.selectedSellingPlanId?.value)
      || digits(document.querySelector('[data-plan]')?.getAttribute('data-plan'));
  }
  return digits(document.querySelector('#SellingPlan, [name="selling_plan"]')?.value);
}

function productFormPayload(form) {
  const variantId = form.querySelector('[name="id"]')?.value;
  const quantity = Number(form.querySelector('[name="quantity"]')?.value || 1);
  const sellingPlan = getSellingPlanId();
  const payload = { id: Number(variantId), quantity };
  if (sellingPlan) payload.selling_plan = Number(sellingPlan);
  return payload;
}

function isAddToCartControl(el) {
  if (!el || el.closest('#cart-drawer, .cart-upsell')) return false;
  if (el.matches('#purchase, [name="add"], [data-sticky-atc]')) return true;
  const text = (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
  return text === 'add to cart' || text === 'adding...' || text === 'adding';
}

async function submitProductForm(form, btn) {
  if (!form) return;
  if (btn) btn.disabled = true;
  try {
    await addToCartAndOpen(productFormPayload(form));
  } catch (err) {
    console.error(err);
    alert(err.message || 'Could not add to cart. Try again.');
  } finally {
    if (btn) btn.disabled = false;
  }
}

function initProductForm() {
  const form = document.getElementById('product-form');
  document.addEventListener('submit', (e) => {
    const submitted = e.target;
    if (!(submitted instanceof HTMLFormElement)) return;
    const action = `${submitted.getAttribute('action') || ''} ${submitted.action || ''}`.toLowerCase();
    if (!action.includes('/cart/add') && submitted.id !== 'product-form') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    submitProductForm(submitted.id === 'product-form' ? submitted : form || submitted, submitted.querySelector('[type="submit"], #purchase'));
  }, true);
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('button, [role="button"], input[type="submit"]');
    if (!isAddToCartControl(btn)) return;
    const host = document.getElementById('product-form');
    if (!host) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    submitProductForm(host, btn);
  }, true);
  document.querySelectorAll('[data-sticky-atc]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      submitProductForm(form, btn);
    });
  });
}

function initCartPage() {
  document.querySelectorAll('.cart-remove-btn').forEach((btn) => {
    btn.addEventListener('click', async () => {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(btn.dataset.line, 10), quantity: 0 }),
      });
      window.location.reload();
    });
  });
}

function initTrackOrderForm() {
  const form = document.getElementById('track-order-form');
  if (!form) return;
  form.addEventListener('submit', () => {
    const orderInput = form.querySelector('[name="order_number"]');
    if (orderInput?.value) orderInput.value = orderInput.value.replace(/^#/, '').trim();
  });
}

function setSellingPlan(value) {
  document.querySelectorAll('#SellingPlan, [name="selling_plan"]').forEach((el) => {
    el.value = value || '';
  });
}

function initKachingSellingPlan() {
  document.addEventListener('kaching-subscriptions:selling-plan-change', (e) => {
    const id = e.detail?.sellingPlanId;
    setSellingPlan(id ? String(id) : '');
  });
}

function appSubscriptionVisible(slot) {
  if (!slot) return false;
  if (slot.querySelector('kaching-subscriptions, kaching-subscriptions-block, kaching-subscriptions-block-v2')) return true;
  const appBits = [...slot.children].filter((el) => !el.matches('[data-ww-sub]'));
  return appBits.some((el) => /powered by seal|subscribe\s*&\s*save|one-time purchase/i.test(el.innerText || ''));
}

function initSubscribeSave() {
  const root = document.querySelector('[data-ww-sub]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  const freq = root.querySelector('[data-ww-freq]');
  const plan = root.querySelector('[data-ww-plan]');
  const sync = () => {
    const mode = root.querySelector('input[name="ww-sub-mode"]:checked')?.value;
    root.querySelectorAll('.ww-sub__opt').forEach((row) => {
      row.classList.toggle('is-on', row.querySelector('input')?.checked);
    });
    if (freq) freq.hidden = mode !== 'sub';
    setSellingPlan(mode === 'sub' ? (plan?.value || '') : '');
  };
  root.querySelectorAll('input[name="ww-sub-mode"]').forEach((input) => {
    input.addEventListener('change', sync);
  });
  plan?.addEventListener('change', sync);
  sync();
}

function placeSubscriptionWidget() {
  const slot = document.querySelector('.kaching-slot');
  if (!slot) return;
  const widgets = document.querySelectorAll([
    'kaching-subscriptions',
    'kaching-subscriptions-block',
    'kaching-subscriptions-block-v2',
    '.kaching-subscriptions',
    '[id*="seal-sub" i]',
    '[id*="sealsub" i]',
    '[class*="seal-subscription" i]',
    '[class*="sealsubscription" i]',
    '[class*="sealsubs-" i]',
    '[data-seal-subscriptions]',
    'seal-subscriptions',
  ].join(', '));
  widgets.forEach((el) => {
    if (el.closest('header, footer, .cart-drawer, .kaching-subscriptions-sticky-atc, .kaching-subscriptions-sticky-atc-wrapper, [data-ww-sub]')) return;
    if (!slot.contains(el)) slot.appendChild(el);
  });
  const fallback = slot.querySelector('[data-ww-sub]');
  if (fallback) fallback.hidden = appSubscriptionVisible(slot);
}

document.addEventListener('DOMContentLoaded', () => {
  guardCartRedirects();
  initNav();
  initAnnouncementTimer();
  initGallery();
  initPibCarousel();
  initReviewsCarousel();
  initBookPacks();
  initProductForm();
  initCartDrawer();
  initCartPage();
  initTrackOrderForm();
  initSubscribeSave();
  initKachingSellingPlan();
  placeSubscriptionWidget();
  const root = document.querySelector('#product-form, [data-mix-bundle], [data-bundle-set]');
  if (root) {
    const watch = new MutationObserver(() => placeSubscriptionWidget());
    watch.observe(document.body, { childList: true, subtree: true });
  }
});
